export default "/assets/webpack-assets/GT-Walsheim-Pro-Medium-Oblique.748f3ff65ba66bc4effea3b149495071.ttf";